import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicroDotBlogComponent } from './simple-icons-micro-dot-blog.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicroDotBlogComponent ],
    exports:      [ SimpleIconsMicroDotBlogComponent ],
    bootstrap:    []
})
export class SimpleIconsMicroDotBlogModule {}
